import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, takeUntil, withLatestFrom } from 'rxjs';
import * as fromRoot from '@app/reducers/index';
import { Store } from '@ngrx/store';
import { DomainActions } from '@app/core/actions';
import { DomainService } from '../domain.service';
import { GetRecordOutput } from '@smash-sdk/domain/ejs/01-2024';


@Injectable({
    providedIn: 'root'
})
export class ResolveDomainService {

    constructor(
        private readonly store$: Store<fromRoot.State>,
        private readonly domainService: DomainService,
    ) { }

    resolve(): Observable<{ domain: GetRecordOutput['record']; }> {
        const detectedDomain = this.domainService.detectDomain();
        const resolvedDomain$ = new ReplaySubject<{ domain: GetRecordOutput['record']; }>();
        this.store$.pipe(
            withLatestFrom(
                this.store$.select(fromRoot.getCurrentDomain),
                this.store$.select(fromRoot.getCurrentDomainLoading),
                this.store$.select(fromRoot.getCurrentDomainLoaded),
                this.store$.select(fromRoot.getLoadDomainError),
            ),
            takeUntil(resolvedDomain$)
        ).subscribe(([_, domain, domainLoading, domainLoaded, error]) => {
            if (domain) {
                resolvedDomain$.next({ domain });
            } else if (!domainLoading && !domainLoaded) {
                this.store$.dispatch(DomainActions.loadDomain({ id: detectedDomain }));
            } else if (error) {
                resolvedDomain$.error(error);
            }
        });

        return resolvedDomain$.asObservable();
    }
}